export default __webpack_public_path__ + "6d22cb5fea179d2cebf14a2e9b20f6e6.svg";